<template>
  <a-layout :class="getClass">
    <a-layout-header v-if="isNotGlsWebsite" class="header">
      <div>
        <img class="logo" src="../../../assets/logo.png" /></div
    ></a-layout-header>
    <div v-if="!loading">
      <a-layout :class="getClasslayout">
        <a-result
          v-if="isInvitationNotValid"
          :status="getInvitationErrorStatus()"
          title="Oops"
          :sub-title="getInvitationErrorMessage()"
        >
        </a-result>
        <a-layout
          v-if="!isInvitationNotValid"
          class="content-container"
          :class="getClasslayout"
        >
          <a-layout-content class="layout-content-container">
            <h2 v-if="isNotGlsWebsite" class="mb-4">
              Set up your own GLS in {{ this.steps.length }} easy steps
            </h2>

            <a-row :gutter="16">
              <a-col :sm="{ span: 4 }" :md="{ span: 8 }">
                <a-steps :current="current" direction="vertical">
                  <a-step
                    v-for="item in steps"
                    :key="item.title"
                    :title="item.title"
                    :description="item.description"
                  />
                </a-steps>
              </a-col>
              <a-col
                :sm="{ offset: 0, span: 18 }"
                :md="{ offset: 1, span: 15 }"
              >
                <div class="steps-content" v-if="!loading">
                  <component
                    :is="steps[current].content"
                    v-bind="dynamicProps"
                    @moveNext="moveNext"
                    @paymentAdded="registerCompany"
                    @validationStarted="() => (isNextBtnLoading = true)"
                    @validationEnded="() => (isNextBtnLoading = false)"
                    @disableNext="handleDisableNext"
                  >
                  </component>
                </div>

                <a-row>
                  <div class="steps-action mt-3">
                    <a-button
                      v-if="current < steps.length - 1 && !loading"
                      type="primary"
                      @click="next"
                      :loading="isNextBtnLoading"
                      :disabled="isNexBtnDisabled"
                    >
                      {{ stepsBtnText }}
                    </a-button>
                  </div>
                </a-row>
              </a-col>
            </a-row>
          </a-layout-content>
        </a-layout>
      </a-layout>
      <a-layout-footer v-if="isNotGlsWebsite">
        Copyright © 2021 Good Law Software</a-layout-footer
      >
    </div>
    <a-spin v-if="loading">
      <a-icon slot="indicator" type="loading" style="font-size: 40px" spin />
    </a-spin>
  </a-layout>
</template>
<script>
import {
  instancesMutations,
  registrationMutations,
  paymentMutations,
  invitationsMutations,
} from "../../../Store/store.js";
import config from "../../../assets/Json/config.json";

const EVENTS = {
  moveNext: "moveNext",
  validationStarted: "validationStarted",
  validationEnded: "validationEnded",
  paymentAdded: "paymentAdded",
  disableNext: "disableNext",
};
const STEPS = {
  BasicDetails: "BasicDetails",
  CompanyDetails: "CompanyDetails",
  Verification: "Verification",
  SubscriptionDetails: "SubscriptionDetails",
  PaymentDetails: "PaymentDetails",
  Finish: "Finish",
};
const INVITATION_STATUSES = {
  1: {
    config: {
      code: 403,
      message: "This invitation has been used already!",
    },
  },
  2: {
    config: {
      code: 404,
      message: "It seems like your GLS invitation has expired!",
    },
  },
};

export default {
  data() {
    return {
      invitationId: window.location.href.split("?")[1],
      invitation: {},
      invitationStatuses: INVITATION_STATUSES,
      company: {
        address: { line1: "", line2: "", postcode: "", countryId: 230 },
        contact: { title: "", name: "", website: "" },
        events: EVENTS,
        type: "",
        verificationCode: "",
        subscription: {},
        payment: { address: { countryId: 230 } },
        subdomain: "",
        imageBase64: "",
      },
      current: 0,
      events: EVENTS,
      steps: [
        {
          title: "Basic Details",
          content: STEPS.BasicDetails,
          description: "Let's set up your account",
          nextBtnText: "Next",
        },
        {
          title: "About Your Company",
          content: STEPS.CompanyDetails,
          description: "Tell us about your company",
          nextBtnText: "Next",
        },
        {
          title: "Verification",
          content: STEPS.Verification,
          description: "Please verify your email",
          nextBtnText: "Next",
        },
        {
          title: "Subscription",
          content: STEPS.SubscriptionDetails,
          description: "Time to select your subscription plan",
          nextBtnText: "Next",
        },
        {
          title: "Payment Details",
          content: STEPS.PaymentDetails,
          description: "Setting your payment details for GLS",
          nextBtnText: "Confirm",
        },
        {
          title: "Done",
          content: STEPS.Finish,
          description: "You are ready to go",
          nextBtnText: "Done",
        },
      ],
      stepsHandler: {},
      dynamicPropsHandler: {
        BasicDetails: () => {
          return {
            company: this.company,
            invitation: this.invitation,
            events: this.events,
            validate: this.validate,
          };
        },
        CompanyDetails: () => {
          return {
            company: this.company,
            events: this.events,
            validate: this.validate,
          };
        },
        Verification: () => {
          return {
            company: this.company,
            events: this.events,
            validate: this.validate,
          };
        },
        SubscriptionDetails: () => {
          return {
            company: this.company,
            invitation: this.invitation,
            events: this.events,
            validate: this.validate,
          };
        },
        PaymentDetails: () => {
          return {
            company: this.company,
            events: this.events,
            validate: this.validate,
            publishableToken: this.publishableToken,
          };
        },
        Finish: () => {
          return {
            company: this.company,
            events: this.events,
            validate: this.validate,
          };
        },
      },
      instancesMutations: instancesMutations,
      registrationMutations: registrationMutations,
      paymentMutations: paymentMutations,
      invitationsMutations: invitationsMutations,
      isNextBtnLoading: false,
      isNexBtnDisabled: false,
      validate: false,
      config: config,
      publishableToken: "",
      loading: true,
    };
  },
  async mounted() {
    await this.setJwt();
    this.publishableToken = await this.getPublishableToken();
    await this.setInvitation();
    if (this.invitation?.isSkipPayment) {
      this.steps.splice(4, 1);
    }
    if (this.invitation?.emailAddress) {
      this.steps.splice(0, 1);
      this.steps.splice(1, 1);
    }

    await this.initStepsHandler();
    this.loading = false;
  },
  methods: {
    next() {
      this.validate = true;
      setTimeout(() => {
        this.validate = false;
      }, 500);
    },
    async moveNext(args) {
      this.stepsHandler[args.source]();
      this.validate = false;
    },
    async setJwt() {
      const res = await this.callStoreMutation(
        "",
        this.registrationMutations.setSignupJwt
      );
      if (!res) {
        this.showError(res);
      } else {
        return res;
      }
    },
    async getPublishableToken() {
      const res = await this.callStoreMutation(
        "",
        this.paymentMutations.getPublishableToken
      );
      if (!res) {
        this.showError(res);
      } else {
        return res.data.result;
      }
    },
    async initStepsHandler() {
      this.stepsHandler = {
        BasicDetails: async () => {
          this.current++;
        },
        CompanyDetails: async () => {
          try {
            let res = await this.registerCompanyDetails();
            if (res?.status == 200 && res?.data?.success) {
              this.company.registrationId = res.data.result;
              this.current++;
            } else {
              this.showError(res);
              this.current--;
            }
          } catch (error) {
            this.showError(error);
            this.current--;
          }
        },

        Verification: async () => {
          this.current++;
        },
        SubscriptionDetails: async () => {
          if (this.invitation?.isSkipPayment) {
            this.addSubscriptionDetails();
            this.current++;
          } else {
            let addSubRes = await this.addSubscriptionDetails();
            if (addSubRes.status == 200 && addSubRes.data.success) {
              let preparePaymentRes = await this.preparePayment();
              if (
                preparePaymentRes.status == 200 &&
                preparePaymentRes.data.success
              ) {
                this.company.payment.clientSecret =
                  preparePaymentRes.data.result.clientSecret;
                this.company.payment.stripeCustomerId =
                  preparePaymentRes.data.result.stripeCustomerId;
                this.current++;
                this.isNexBtnDisabled = true;
              } else {
                this.showError(preparePaymentRes);
              }
            } else {
              this.showError(addSubRes);
            }
          }
        },
      };
    },
    async registerCompanyDetails() {
      let request = {
        email: this.company.email,
        tokenKey: this.config.businessTokenKey,
        firstName: this.company.contact.firstName,
        lastName: this.company.contact.lastName,
        phoneNumber: this.company.contact.phone,
        companyName: this.company.name,
        website: this.company.contact.website,
        title: this.company.contact.title,
        firmSizeId: this.company.size,
        firmTypeId: this.company.type,
        companyAddress: this.company.address,
        subdomain: this.company.subdomain,
        invitationId: this.invitation?.id,
        overridedUnitPrice: this.invitation?.overridedPrice,
      };
      return await this.callStoreMutation(
        request,
        this.registrationMutations.registerCompanyDetails
      );
    },
    async addSubscriptionDetails() {
      let request = {
        subscriptionPlanId: this.company.subscription.subscriptionPlanId,
        registrationId: this.company.registrationId,
        skipPayment: this.invitation?.isSkipPayment,
        channelId: this.invitation?.channelId,
        overridedUnitPrice: this.invitation?.overridedPrice,
        invitationId: this.invitation?.id,
        subscriptionQuantity: this.company.subscription.subscriptionQuantity
      };
      return await this.callStoreMutation(
        request,
        this.registrationMutations.addSubscriptionDetails
      );
    },
    async preparePayment() {
      let request = {
        email: this.company.email,
        name: this.company.name,
      };
      return await this.callStoreMutation(
        request,
        this.registrationMutations.preparePayment
      );
    },
    async registerCompany(event) {
      let request = {
        registerationId: this.company.registrationId,
        stripeCustomerId: this.company.payment.stripeCustomerId,
        billingAddressLine1: this.company.payment.address.addressLine1,
        billingAddressLine2: this.company.payment.address.addressLine2,
        billingAddressPostCode: this.company.payment.address.postcode,
        billingAddressCountryId: this.company.payment.address.countryId,
        paymentMethodId: event.payment_method,
        cardHolderName: event.cardholderName,
        skipPayment: this.invitation?.isSkipPayment,
        channelId: this.invitation.channelId,
        imageBase64: this.company.imageBase64,
        invitationId: this.invitation?.id,
        overridedUnitPrice: this.invitation?.overridedPrice,
        subscriptionQuantity: this.company.subscription.subscriptionQuantity
      };
      this.callStoreMutation(
        request,
        this.registrationMutations.registerCompany
      );
      this.current++;
    },
    async callStoreMutation(request, func) {
      this.isNextBtnLoading = true;
      try {
        return await func(request);
      } catch (error) {
        this.showError(error);
      } finally {
        this.isNextBtnLoading = false;
      }
    },
    handleDisableNext(val) {
      this.isNexBtnDisabled = val;
    },
    async setInvitation() {
      try {
        if (this.invitationId) {
          var res = await this.invitationsMutations.getInvitation(
            this.invitationId
          );
          if (res?.status == 200 && res?.data?.success) {
            this.invitation = res.data.result;
            this.company.email = this.invitation.emailAddress;
          }
        }
      } finally {
        this.loading = false;
      }
    },
    getInvitationErrorStatus() {
      return this.invitationStatuses[this.invitation.status]?.config?.code;
    },
    getInvitationErrorMessage() {
      return this.invitationStatuses[this.invitation.status]?.config?.message;
    },
  },
  computed: {
    dynamicProps() {
      return this.dynamicPropsHandler[this.steps[this.current].content]();
    },
    stepsBtnText() {
      return this.steps[this.current].nextBtnText;
    },
    isNotGlsWebsite() {
      return window.location.href.includes('?');
    },
    getClass() {
      return !window.location.href.includes('?') ? "gls-site" : "";
    },
    getClasslayout() {
      return !window.location.href.includes('?')
        ? "gls-site-content"
        : "main-layout";
    },
    isInvitationNotValid() {
      return this.invitation?.status != 0 && !!this.invitation.id;
    },
  },
  components: {
    BasicDetails: () => import("./BasicDetails.vue"),
    SubscriptionDetails: () => import("./SubscriptionDetails.vue"),
    CompanyDetails: () => import("./CompanyDetails.vue"),
    PaymentDetails: () => import("./PaymentDetails.vue"),
    Verification: () => import("./Verification.vue"),
    Finish: () => import("./Finish.vue"),
  },
};
</script>

<style lang="scss">
.gls-site {
  margin: 25px auto;
  width: 90%;
}
.gls-site-content {
  background-color: #fff !important;
}
.logo {
  max-width: 40px;
  margin: 12px 25px 12px 0;
  float: left;
}

.main-layout {
  min-height: calc(100vh - 134px);
  overflow-y: auto;

  .layout-content-container {
    background-color: #fff;
    padding: 15px;
    margin: 0px;
    min-height: calc(100% - 10px);
    height: 100%;
  }

  .content-container {
    max-width: 70vw;
    min-width: calc(max(70vw, 980px));
    margin: 10px auto;
  }
}

.steps-action {
  float: left;
}

.step-btn {
  margin: 0px 5px 0px 5px;
}

.steps-content {
  text-align: center !important;
}

.steps-content p {
  text-align: left !important;
}

.steps-content .step-item {
  text-align: left !important;
}

.spinner {
  font-size: 40px;
  float: left;
}

.ant-steps-icon {
  line-height: 32px !important;
}
</style>
